import { _ } from "libs";

import React from "react";
import PlayerItemMediumCard from "../items/player/mediumCard";
import { NewNetworkMemberActivity } from "../../types";
import { formatName } from "../../libs/formatName";
import { openPlayerPopup } from "../../actions";

const NewNetworkMember = ({ activities }: { activities: NewNetworkMemberActivity[] }) => {
	return (
		<div className="nBlock fixedHeader">
			<h5>{_("timeline.newNetworkMembers.heading")}</h5>
			<div className="newsFeedPlayers">
				{activities.map((activity, index) => {
					return (
						<div
							className="clickable"
							onClick={() => openPlayerPopup(activity.actor.data.userId)}
							key={index}
						>
							<PlayerItemMediumCard
								photoUrl={activity.actor.data.photoUrl}
								name={formatName(activity.actor.data.firstName, activity.actor.data.lastName)}
								meta={activity.actor.data.rating ? activity.actor.data.rating.ITNName : null}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default NewNetworkMember;
